export default __webpack_public_path__ + "static/media/half-circle.524b3124.svg";